"use client";

import { Text } from "rizzui";
import cn from "@core/utils/class-names";
import SimpleBar from "@core/ui/simplebar";
import MetricCard from "@core/components/cards/metric-card";
import { Area, AreaChart, ResponsiveContainer } from "recharts";
import TrendingUpIcon from "@core/components/icons/trending-up";
import TrendingDownIcon from "@core/components/icons/trending-down";
import { getChartColorByEngagementRate } from "@core/components/table-utils/get-chart-color-by-engagement-rate";
import { User } from "packages/app/src/types";
import { useEffect, useState } from "react";

interface StatsCardsProps {
  className?: string;

}

export default function UsersStatCard({ className, }: StatsCardsProps) {

  const DummyStatsData = [
    {
      id: 1,
      title: "Total Users",
      metric: 4573,
      fill: "#3872FA",
      percentage: 30,
      increased: true,
      decreased: false,
      value: "+32.40",
      engagementRate: 70.03,
      chart: [
        {
          label: "1",
          count: 21,
        },
        {
          label: "2",
          count: 23,
        },
        {
          label: "3",
          count: 16,
        },
        {
          label: "4",
          count: 87,
        },
        {
          label: "5",
          count: 49,
        },
        {
          label: "6",
          count: 100,
        },
        {
          label: "7",
          count: 88,
        },
        {
          label: "8",
          count: 57,
        },
        {
          label: "9",
          count: 86,
        },
        {
          label: "10",
          count: 73,
        },
        {
          label: "11",
          count: 57,
        },
        {
          label: "12",
          count: 32,
        },
        {
          label: "13",
          count: 39,
        },
        {
          label: "14",
          count: 99,
        },
        {
          label: "15",
          count: 12,
        },
        {
          label: "16",
          count: 33,
        },
        {
          label: "17",
          count: 26,
        },
        {
          label: "18",
          count: 50,
        },
        {
          label: "19",
          count: 18,
        },
        {
          label: "20",
          count: 48,
        },
      ],
    },

    {
      id: 12,
      title: "New Users This Week",
      metric: 20,
      fill: "#3872FA",
      percentage: 54,
      increased: true,
      decreased: false,
      value: "+14.45",
      engagementRate: 67.92,
      chart: [
        {
          label: "1",
          count: 17,
        },
        {
          label: "2",
          count: 70,
        },
        {
          label: "3",
          count: 18,
        },
        {
          label: "4",
          count: 34,
        },
        {
          label: "5",
          count: 16,
        },
        {
          label: "6",
          count: 57,
        },
        {
          label: "7",
          count: 24,
        },
        {
          label: "8",
          count: 67,
        },
        {
          label: "9",
          count: 83,
        },
        {
          label: "10",
          count: 18,
        },
        {
          label: "11",
          count: 96,
        },
        {
          label: "12",
          count: 57,
        },
        {
          label: "13",
          count: 34,
        },
        {
          label: "14",
          count: 96,
        },
        {
          label: "15",
          count: 27,
        },
        {
          label: "16",
          count: 25,
        },
        {
          label: "17",
          count: 26,
        },
        {
          label: "18",
          count: 74,
        },
        {
          label: "19",
          count: 49,
        },
        {
          label: "20",
          count: 72,
        },
      ],
    },
  ];
  return (
    <SimpleBar>
      <div className="grid grid-cols-1 gap-5 @xl:grid-cols-2 @4xl:col-span-2 @6xl:grid-cols-4 @7xl:col-span-12 3xl:gap-8">
        {DummyStatsData.map((stat: any) => {
          return (
            <MetricCard
              key={stat.id}
              title={stat.title}
              metric={stat.metric}
              chartClassName="w-44"
              metricClassName="3xl:text-[22px]"
              className={cn("w-full max-w-full justify-between", className)}
              chart={
                <div className="ms-auto h-12 w-full 4xl:h-9">
                  <ResponsiveContainer width="100%" height="100%">
                    <AreaChart
                      data={stat.chart}
                      margin={{
                        left: -30,
                      }}
                    >
                      <defs>
                        <linearGradient
                          id={`deviceSessionsMobile-${stat.id}`}
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="5%"
                            stopColor="#F0F1FF"
                            className="[stop-opacity:0.25] dark:[stop-opacity:0.2]"
                          />
                          <stop
                            offset="95%"
                            stopColor={getChartColorByEngagementRate(
                              stat.engagementRate
                            )}
                            stopOpacity={0}
                          />
                        </linearGradient>
                      </defs>
                      <Area
                        type="bump"
                        dataKey="count"
                        stroke={getChartColorByEngagementRate(
                          stat.engagementRate
                        )}
                        strokeWidth={1.8}
                        fillOpacity={1}
                        fill={`url(#deviceSessionsMobile-${stat.id})`}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              }
            >
              <Text className="mt-5 flex items-center leading-none text-gray-500">
                <Text
                  as="span"
                  className={cn(
                    "me-2 inline-flex items-center font-medium",
                    stat.increased ? "text-green" : "text-red"
                  )}
                >
                  {stat.increased ? (
                    <TrendingUpIcon className="me-1 h-4 w-4" />
                  ) : (
                    <TrendingDownIcon className="me-1 h-4 w-4" />
                  )}
                  {stat.value}%
                </Text>
                {stat.increased}
                {/* {stat.increased ? 'Increase' : 'Decrease'} */}
              </Text>
            </MetricCard>
          );
        })}
      </div>
    </SimpleBar>
  );
}
